import { encodeToUrlParams } from "@utils/common";
/*
 *
 * Config for API
 *
 */

const BASE_URL = "/";
const HUB_HOST = `${process.env.HUB_HOST}/`;
const PARTNER_BASE_URL = `${process.env.PARTNER_HOST}`

const API_ENDPOINTS = {
  AUTH: {
    MERCHANTS: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}`,
    LOGOUT: `${BASE_URL}api/v1/user/logout`,
    KAM_TOKEN_INFO: ({ mid }) => `${BASE_URL}api/v1/oauth/token/info?mid=${mid}`,
    TOKEN_INFO: `${BASE_URL}api/v1/oauth/token/info`
  },
  HUB: {
    VERIFY_PASSWORD: `${HUB_HOST}oauth/token`,
    FIND_OR_CREATE: `${HUB_HOST}api/v1/users/find_or_create`,
    TOKEN: `${HUB_HOST}oauth/token.json`,
  },
  MASTER_DATA: {
    BUSINESS_ENTITIES: `${BASE_URL}api/v1/business_entities`,
    DOC_CATEGORY_TYPE: `${BASE_URL}api/v1/document_categories_and_types`,
    AREA_CODES: `${BASE_URL}api/v1/area_codes`,
  },
  GET_DISPLAY_NAMES: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/fetch_display_name`,
  UPDATE_PASSWORD: `${BASE_URL}api/v1/user/update_password`,
  PAN_GSTIN: (merchantUUID) => `${BASE_URL}api/v1/dvs_wrapper/${merchantUUID}/pan_gst_details`,
  PAN_LINKED_GST: (merchantUUID) => `${BASE_URL}api/v1/dvs_wrapper/${merchantUUID}/gst_details`,
  GST_DETAILS: (merchantUUID) => `${BASE_URL}api/v1/dvs_wrapper/${merchantUUID}/gstin_details`,
  SUBMIT_ONBOARDING_DETAILS: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}`,
  SHOP_DETAILS: (merchantUUID) => `${BASE_URL}api/v1/dvs_wrapper/${merchantUUID}/shop_details`,
  ONBOARDING: {
    BUSINESS_CATEGORY: `${BASE_URL}api/v1/business_category`,
    LIVELINESS_CHECK: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/website_details`,
    UPDATE_DOMAIN_STATUS: (merchantUUID, websiteUUID) =>
      `${BASE_URL}api/v1/merchants/${merchantUUID}/website_details/${websiteUUID}`,
    CREATE_USER: (userUuid) =>  `${BASE_URL}api/v1/user/create_user/${userUuid}`,
    // UPDATE_BUSINESS_DETAILS: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/update_business_details`,
    DELETE_ULTIMATE_BENEFICIARY_OWNER: (merchantUUID, uboId) => `${BASE_URL}api/v1/merchants/${merchantUUID}/ultimate_beneficiaries/${uboId}`
  },
  DOCUMENTS: {
    DOCUMENT_DETAILS: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc_documents/merchant_docs_req`,
    UPLOAD_DOCUMENT: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc_documents`,
    UPLOAD_DOC_ATTACHMENT: (merchantUUID) =>
      `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc_documents/append_attachment`,
    REMOVE_DOCUMENT: (merchantUUID, docUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc_documents/${docUUID}`,
    REMOVE_DOCUMENT_ATTACHMENT: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/attachment`,
    MERGE_DOCUMENTS: (merchantUUID, docId) =>
      `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc_documents/${docId}/merge_documents`,
    DOWNLOAD_SIGNING_AUTHORITY_LETTER: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc_documents/generate_authority_letter`,
    DOWNLOAD_SCHEDULE_C_SAMPLE: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc_documents/generate_schedule_c_document`,
    DOWNLOAD_BENEFICIARY_SAMPLE:  (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc_documents/generate_beneficiary_list`,
    VERIFY_DOCUMENT_STATUS: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc_documents/receive_all_docs`,
  },
  UPDATE_BANK_DETAILS: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/bank_details`,
  UPLOAD_BANK_PROOF: (merchantUUID) =>
    `${BASE_URL}api/v1/merchants/${merchantUUID}/bank_details/bank_verification_by_bank_proof`,
  UPDATE_GSTN: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/update_gst_details`,
  IFSC: {
    BANK_NAMES: `${BASE_URL}api/v1/ifsc_details/bank_names`,
    STATES: (params) => `${BASE_URL}api/v1/ifsc_details/states?${encodeToUrlParams(params)}`,
    CITIES: (params) => `${BASE_URL}api/v1/ifsc_details/cities?${encodeToUrlParams(params)}`,
    BRANCHES: (params) => `${BASE_URL}api/v1/ifsc_details/branches?${encodeToUrlParams(params)}`,
    DETAILS: (ifscCode) => `${BASE_URL}api/v1/ifsc_details/${ifscCode}`,
  },
  OTP: {
    SEND: `${HUB_HOST}api/v1/otps`,
    VERIFY: `${HUB_HOST}api/v1/otps/verify`,
  },
  CIN: {
    SIGNATORIES_DETAILS: (merchantUUID) => `${BASE_URL}api/v1/dvs_wrapper/${merchantUUID}/signing_authority_details`,
  },
  SUBMIT_SIGNING_AUTHORITY: (accountUUID) => `${BASE_URL}api/v1/accounts/${accountUUID}`,
  UPDATE_SIGNING_AUTHORITY: (accountUUID) => `${BASE_URL}api/v1/accounts/${accountUUID}/update_signatory_detail`,
  KYC: {
    CENTRAL: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc/ckyc_data`,
    AADHAR: {
      CONSENT: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc/aadhaar_xml_consent`,
      SEND_OTP: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc/aadhaar_xml_otp_generation`,
      VERIFY_OTP: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc/aadhaar_xml_file_data`,
      XML_SHARE_CODE: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc/aadhaar_file_details`,
    },
    STATUS: (merchantUUID) => `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc/kyc_status`,
  },
  SERVICE_AGREEMENT: {
    GENERATED: merchantUUID => `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc_documents/generated_agreements`,
    HTML: kycDocumentUuid => `${BASE_URL}api/v1/kyc_document/${kycDocumentUuid}/generated_agreement_html`,
    GENERATE_MERGED_DOCUMENT_ESIGN: merchantUUID => `${BASE_URL}api/v1/merchants/${merchantUUID}/generate_merged_document_for_esign`,
    SEND_SINGNATORY_OTP: ({
      kycDocumentUuid,
      merchantUuid,
    }) => `${BASE_URL}api/v1/merchants/${merchantUuid}/kyc_documents/${kycDocumentUuid}/send_signatory_otp`,
    ESIGN_MERGED_DOCUMENT: ({ merchantUuid, kycDocumentUuid }) =>
      `${BASE_URL}api/v1/merchants/${merchantUuid}/kyc_documents/${kycDocumentUuid}/esign_merged_document`,
    ESIGNED_DOCUMENT: (merchantUUID, params) => `${BASE_URL}api/v1/merchants/${merchantUUID}/kyc_documents?${encodeToUrlParams(params)}`,
  },
  TIMELINE: merchantUUID => `${BASE_URL}api/v1/merchants/${merchantUUID}/status_timeline`,
  PINCODE_DETAILS: (pinCode) => `${BASE_URL}api/v1/pincode_details/${pinCode}`,
  COMMENTS: {
    WEBSITE: ({ merchantUUID, websiteUUID }) =>
      `${BASE_URL}api/v1/merchants/${merchantUUID}/website_details/${websiteUUID}/comments`,
    CREATE_WEBSITE_DOCUMENT: ({ merchantUUID, websiteUUID }) =>
      `${BASE_URL}api/v1/merchants/${merchantUUID}/website_details/${websiteUUID}/create_website_documents`,
  },
  PARTNER: {
    DETAILS: `${PARTNER_BASE_URL}/api/v1/partners/fetch_platform_details`,
    AUTHORIZE_PARTNER : `${PARTNER_BASE_URL}/api/v1/merchants/auth_code`,
    LINK_PARTNER : `${PARTNER_BASE_URL}/api/v1/merchants/link_partner`,
  }
};

export default API_ENDPOINTS;
